import Vue from 'vue';
import GameRoleSelect from './game-role-select.vue';
import ConfirmGameRole from './confirm-game-role.vue';
export default {
  showGameRoleSelect(gameCode, { context = null, defaultPartitionId, defaultRoleId, option } = {}) {
    return new Promise((resolve) => {
      const GameRoleSelectCreator = Vue.extend(GameRoleSelect);

      const gameRoleSelect = new GameRoleSelectCreator({
        el: document.createElement('div'),
        created() {
          this.game_code = gameCode;
          this.options = {
            defaultPartitionId: defaultPartitionId || '',
            defaultRoleId: defaultRoleId || '',
          };
          this.option = option;
          this.$on('finish', (gameRoleInfo) => {
            this.$destroy();
            resolve(gameRoleInfo, this.$el);
          });

          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(gameRoleSelect.$el);
    });
  },
  showConfirmGameRole({
    context = null,
    gameCode,
    roleInfoObj,
    option,
  } = {}) {
    return new Promise((resolve) => {
      const ConfirmGameRoleCreator = Vue.extend(ConfirmGameRole);

      const confirmGameRole = new ConfirmGameRoleCreator({
        el: document.createElement('div'),
        created() {
          this.gameCode = gameCode;
          this.roleInfoObj = roleInfoObj;
          this.option = option;

          this.$on('confirmReward', (roleInfo) => {
            this.$destroy();
            resolve(roleInfo);
          });
          this.$on('close', () => {
            this.$destroy();
          });

          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(confirmGameRole.$el);
    });
  },
};
